<div class="innerBanner">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="">
                        <!-- <a href="javascript:void(0);" class="backLink"><b><img
                                    src="assets/images/icons/backarrow.png" /></b>BACK TO COURSE DETAILS</a> -->
                    </div>
                    <div class="viewerModule">
                        <h2>{{moduleName}}</h2>
                        <div class="engineWrap">
                            <div class="joinerDetails mb-0">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/doughnut_chart.svg">
                                </span>
                                <!-- <div class="joinerContent">
                                <h3>15%</h3>
                                <div class="ghrapWrap mb-0">
                                    <span style="width: 15%;"></span>
                                </div>
                            </div> -->
                            </div>
                        </div>

                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span *ngIf="ModulSubData!=''">{{ModulSubData.submodule_name}}</span>
                            <h2 *ngIf="ModulSubData!=''">{{ModulSubData.submodule_desc}}</h2>
                        </div>
                        <div class="viewerModifyi">
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img
                                            src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <input type="hidden" (click)="open(multiloginValidation)" id="successMsg">
                </div>
                <div class="col-12 col-md-6">

                    <!-- <div class="timerWrap countdown">
                        <ul>
                            <li>
                                <div class="timer ">
                                    <span>01</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>10</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>34</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
</div>
<div class="dynamicBookWrap" *ngIf="isPassed == 1 && moduleId == EvaluationResult.module_id && courseStatus!=3">
    <div class="container">
        <div class="row">
            <div class="resultWrap">
                <div class="resul_img">
                    <img src="assets/images/thumb-up.png" />
                </div>
                <h4>Congratulations, you have passed the Assessment!</h4>
                <span class="divider"></span>
                <p *ngIf="isLastSubmodule==0">You can now start the next submodule</p>
                <p *ngIf="isLastSubmodule==1">You can now start the moudle assessment</p>
                <div class="moduleVideoWrap">
                    <b>
                        <img src="assets/images/icons/play_circle_filled.svg">
                    </b>
                    <div class="moduleBox" *ngIf="isLastSubmodule == 0">
                        <span>{{EvaluationResult.module_name}}</span>
                        <span>{{EvaluationResult.submodule_name}}</span>
                    </div>
                    <div class="moduleBox" *ngIf="isLastSubmodule==1">
                        <span>{{EvaluationResult.module_name}}</span>
                    </div>
                    <a href="javascript:void(0);" *ngIf="isLastSubmodule==1" class="btn btn-primary"
                        [routerLink]="['/viewer-details']"
                        [queryParams]="{course_id:courseId, module_id:moduleId,assId:assId,AT:1 }">Start assessment</a>
                    <a href="javascript:void(0);" *ngIf="isLastSubmodule==0" class="btn btn-primary"
                        (click)="goViewer(EvaluationResult.module_id,EvaluationResult.submodule_id,courseId)">Start</a>
                </div>
                <div class="btnWrap">
                    <a href="javascript:void(0);" class="backPage" [routerLink]="['/assigned_details_resume']"
                        [queryParams]="{courseId:courseId}">Back to course details</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dynamicBookWrap" *ngIf="isPassed == 1 && moduleId != EvaluationResult.module_id && courseStatus!=3">
    <div class="container">
        <div class="row">
            <div class="resultWrap pt-3">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                <h4>Congratulations, you have passed the module Assessment!</h4>
                <span class="divider"></span>
            <br/>
            <br/>
                <!-- <p>You can download this module’s certificate and start the next module</p> -->
                <div class="illusBtnWrap">
                    <div class="moduleVideoWrap flex-wrap-nowrap">
                        <b>
                            <img src="assets/images/icons/play_circle_filled.svg">
                        </b>
                        <div class="moduleBox">
                            <span>{{EvaluationResult.module_name}}</span>
                            <span>{{EvaluationResult.submodule_name}}</span>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-primary"
                            (click)="goViewer(EvaluationResult.module_id,EvaluationResult.submodule_id,courseId)">Start</a>
                    </div>
                    <div class="btnWrap">
                        <a href="javascript:void(0);" [routerLink]="['/assigned_details_resume']"
                            [queryParams]="{courseId:courseId}" class="backPage">Back to course details</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
<div class="dynamicBookWrap" *ngIf="courseStatus == 3">
    <div class="container">
        <div class="row">
            <div class="resultWrap pt-3">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                <h4>Congratulations, you have completed course!</h4>
                <span class="divider"></span>
                <br/>
                <br/>
                <a href="javascript:void(0);" class="btn btn-primary download" (click)="downloadCartiCourse()">Download
                    Certificate</a>

                <div class="illusBtnWrap">
                    <div class="moduleVideoWrap">
                        <!-- <b>
                            <img src="assets/images/icons/play_circle_filled.svg">
                        </b> -->
                    </div>
                    <div class="btnWrap">
                        <a href="javascript:void(0);" [routerLink]="['/completed']" class="backPage">Back to course</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dynamicBookWrap" *ngIf="type == 'ass'">
    <div class="container">
        <div class="row">
            <div class="resultWrap pt-3">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                <h4>Congratulations, you have passed the Assessment!</h4>
                <span class="divider"></span>
            <br/>
            <br/>
                <!-- <p>You can download this module’s certificate and start the next module</p> -->
                <div class="illusBtnWrap">
                    <div class="btnWrap">
                        <a href="javascript:void(0);" [routerLink]="['/assessments']" class="backPage">Back to assessments</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>